import { createFileRoute } from "@tanstack/react-router"
import NotFound from "~/components/reusable/NotFound"
import { Module, OverviewPage } from "~/components/design-system/pages"
import { Badge } from "~/components/design-system/components"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { useBudgetTimelineSettings } from "~/hooks/useBudgets"
import { useAllBudgets } from "~/hooks/useAllBudgets"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import { useFlags } from "~/features/feature-flags"
import BudgetTimelineCard from "~/components/budget/timeline/BudgetTimelineCard"
import BudgetTimelineSettingsDialog from "~/components/budget/timeline/BudgetTimelineSettingsDialog"
import BudgetSetupChecklist from "~/components/budget/timeline/BudgetSetupChecklist"
import { useGetCollections } from "~/hooks/useCollections"

export const Route = createFileRoute("/_auth/budgets/_layout/timeline")({
  component: RouteComponent,
})

function RouteComponent() {
  const { budget: budgetFlag } = useFlags()
  const { isLoading } = useAllBudgets()
  const { data: collections } = useGetCollections()

  const { isConfigured: areSettingsConfigured } = useBudgetTimelineSettings()

  if (budgetFlag === false) {
    return <NotFound />
  }

  const hasCollections = (collections?.length ?? 0) > 0
  const isSetupComplete = hasCollections && areSettingsConfigured

  return (
    <Module
      breadcrumb={
        <>
          <BreadcrumbWrapper />
          <Badge size="sm" variant="violet">
            Beta
          </Badge>
        </>
      }
      actions={isSetupComplete ? <BudgetTimelineSettingsDialog /> : undefined}
    >
      <OverviewPage fillContent>
        {isLoading ? (
          <LoadingOverlay />
        ) : !isSetupComplete ? (
          <div className="flex flex-1 items-center justify-center">
            <BudgetSetupChecklist
              hasCollections={hasCollections}
              hasConfiguredSettings={areSettingsConfigured}
            />
          </div>
        ) : (
          <BudgetTimelineCard />
        )}
      </OverviewPage>
    </Module>
  )
}
